const SCRIPT_SELECTOR = 'script[data-goatcounter]';

export function getGoatCounterEndpoint() {
  return process.env.REACT_APP_GOATCOUNTER_ENDPOINT?.trim() || "";
}

export function shouldLoadGoatCounter({
  endpoint = getGoatCounterEndpoint(),
  nodeEnv = process.env.NODE_ENV,
  allowLocal = process.env.REACT_APP_GOATCOUNTER_ALLOW_LOCAL === "true",
} = {}) {
  if (!endpoint) return false;
  if (nodeEnv === "development" && !allowLocal) return false;
  return true;
}

export function getPageviewPath({ pathname, search = "", hash = "" }) {
  return `${pathname}${search}${hash}`;
}

export function countPageview(path) {
  if (typeof window === "undefined") return;
  window.goatcounter?.count?.({ path });
}

export function loadGoatCounterScript(endpoint, documentRef = typeof document !== "undefined" ? document : undefined) {
  if (typeof documentRef === "undefined") {
    return Promise.resolve();
  }

  if (documentRef.querySelector(SCRIPT_SELECTOR)) {
    return Promise.resolve();
  }

  if (typeof window !== "undefined") {
    window.goatcounter = { no_onload: true };
  }

  return new Promise((resolve, reject) => {
    const script = documentRef.createElement("script");
    script.async = true;
    script.src = "https://gc.zgo.at/count.js";
    script.dataset.goatcounter = endpoint;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("GoatCounter script failed to load"));
    documentRef.head.appendChild(script);
  });
}
